module.exports = __webpack_public_path__ + "static/media/fastcharge-icon.bed2ddf4.svg";